import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import { Container, HtmlContent, Grid, Heading } from '../components/ui';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import ContactForm from '../components/ContactForm';
import ShopLocations from '../components/ShopLocations';
import { getSchemaDescription } from '../utils';

const ContactPage = () => {
  const {
    datoCmsContact: { seoMetaTags, title, content },
  } = useStaticQuery(graphql`
    query ContactPageQuery {
      datoCmsContact {
        seoMetaTags {
          ...GatsbyDatoCmsSeoMetaTags
        }
        title
        content
      }
    }
  `);

  return (
    <Layout title={title} description={getSchemaDescription(seoMetaTags)}>
      <HelmetDatoCms seo={seoMetaTags} />
      <main>
        <PageHeader heading={title} />
        <Container>
          <HtmlContent html={content} center={true} />
          <Grid>
            <ContactForm isContactPage={true} />
            <Heading hide={true}>Shop Locations</Heading>
            <ShopLocations />
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default ContactPage;
